"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_HIGHLIGHT_PADDING = void 0;
exports.DEFAULT_HIGHLIGHT_PADDING = 10;
//# sourceMappingURL=constants.js.map